<script>
  export let item
  export let base
</script>

<div class="container pad">
  <div class="row">
    <div class="col-md-2" />
    <div class="col-md-8 text-center">
      <h1>
        {#if item.title}{item.title}{:else}Lorem Ipsum{/if}
      </h1>

      <p>
        {@html item.body}
      </p>

    </div>
    <div class="col-md-2" />
  </div>
</div>
